/**
 * The NVR release a server runs, as users see it (ADR-183, decision D2).
 *
 * A server sends sReleaseVersion (V = YYYY.M.N, or dev-<commit>) beside the
 * unchanged sVersion (6.2.90). sVersion stays internal: the client/server
 * compatibility checks keep comparing it. An older server, and every entry in
 * the connected-server list (those come from the Server table), has no
 * sReleaseVersion, so the display falls back to sVersion.
 */

/** "2026.9.4", "2026.9.4 (candidate)", "dev-<commit>", else the server's sVersion (or ''). */
export function serverVersionLabel(server) {
  if (!server) return '';
  const release = typeof server.sReleaseVersion === 'string' ? server.sReleaseVersion : '';
  if (release) {
    return server.fReleaseCandidate && !release.startsWith('dev-') ? `${release} (candidate)` : release;
  }
  return server.sVersion || '';
}

/** The status-bar / system-details form: the release, or "DVS v<sVersion>" from an old server. */
export function statusVersionLabel(server) {
  if (server && server.sReleaseVersion) return serverVersionLabel(server);
  return server && server.sVersion ? `DVS v${server.sVersion}` : '';
}

/** "v2026.9.4" for a numeric version, anything else ("dev-…") as is. */
export function versionTag(label) {
  if (!label) return '';
  return /^\d/.test(label) ? `v${label}` : label;
}
